import { OthercodeGet } from "@kase/my-marathon-communication";
import { ApiSliceParams } from "../interfaces";
import { createListController } from "../utils";
import { OtherCode } from "./interfaces";

export const makeOtherCode = ({ connection, company }: ApiSliceParams) => {
    const {
        items: codes,
        allLoading: loading,
        listen,
    } = createListController<OthercodeGet, OtherCode>({
        name: "othercode",
        connection,
        list: (con) => con.othercode.items({ company: company.value }),
    });

    return { codes, loading, listen };
};
